import React, {useState} from 'react';
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {
    MARKETS_LIST,
    PRODUCT_UPLOAD_TABS_LIST
} from "../../constants/pod.constant";
import {
    SYNC_PRINTFUL_DASHBOARD_TABS_LIST
} from "../../../printful/constants/printful.constant";
import PrintfulStoresList from "../../../printful/components/printful-stores/printful-stores-list";
import PrintfulCategoriesList from "../../../printful/components/printful-categories/printful-categories-list";
import PrintfulProductTypesList from "../../../printful/components/printful-product-types/printful-product-types-list";
import PrintfulProductsList from "../../../printful/components/printful-products/printful-products-list";
import PrintfulProductVariantsList
    from "../../../printful/components/printful-product-variants/printful-product-variants-list";
import {addProducts, batchSaveProducts, getAllPODProducts, updateProducts} from "../../services/product-data-service";
import {
    addParentProducts, batchUpdateParentProducts,
    getAllPODParentProducts,
    updateParentProducts
} from "../../services/parent-product-data-service";
import {getSinglePrintfulInfo} from "../../../printful/services/printful-info-data.service";
import {PRINTFUL_INFO_IDS} from "../../../printful/constants/printful-info.constant";
import {getAllPrintfulProducts} from "../../../printful/services/printful-products-data.service";
import {getAllPrintfulProductVariants} from "../../../printful/services/printful-product-variants-data.service";
import {prepareProductsForAddOrUpdate} from "../../utils/product-data-util";
import {prepareParentProductsForAddOrUpdate} from "../../utils/parent-product-data-util";
import {
    preparePrintfulParentProductsForAddOrUpdate,
    preparePrintfulProductTypeAndCategories
} from "../../utils/printful-parent-product-data-util";
import {prepareProductTypeAndCategories} from "../../utils/uploaded-product-data-util";
import {getAllPrintfulLayoutTemplates} from "../../../printful/services/printful-layout-templates-data.service";
import {preparePrintfulProductsForAddOrUpdate} from "../../utils/printful-product-data-util";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";

const tabsList = PRODUCT_UPLOAD_TABS_LIST;
const marketsList = MARKETS_LIST;

const printfulTabsList = SYNC_PRINTFUL_DASHBOARD_TABS_LIST;

const SyncProductsDashboard = ({podDetail, setPodDetail}) => {
    const [productStatistics, setProductStatistics] = useState(null);
    const [saveProductsInProgress, setSaveProductsInProgress] = useState(false);
    const [uploadedProducts, setUploadedProducts] = useState(null);
    const [latestProductsList, setLatestProductsList] = useState(null);
    const [latestParentProductsList, setLatestParentProductsList] = useState(null);
    const [uploadedProductFields, setUploadedProductFields] = useState(null);
    const [selectedTab, setSelectedTab] = useState(SYNC_PRINTFUL_DASHBOARD_TABS_LIST[0]);
    const [productTypes, setProductTypes] = useState(null);

    const saveProducts = async () => {
        setSaveProductsInProgress(true);

        /*const existingProducts = await getAllPODProducts(podDetail.id);
        const existingParentProducts = await getAllPODParentProducts(podDetail.id);

        const processedProducts = prepareProductsForAddOrUpdate(latestProductsList, existingProducts);
        const processedParentProducts = prepareParentProductsForAddOrUpdate(latestParentProductsList, existingParentProducts);

        setProductStatistics({
            products: {
                add: processedProducts.add.length,
                update: processedProducts.update.length,
            },
            parentProducts: {
                add: processedParentProducts.add.length,
                update: processedParentProducts.update.length,
            }
        });

        await addProducts(processedProducts.add);
        await updateProducts(processedProducts.update);

        await addParentProducts(processedParentProducts.add);
        await updateParentProducts(processedParentProducts.update);*/

        setSaveProductsInProgress(false);
    }

    const syncProductsAndVariants = async () => {
        setSaveProductsInProgress(true);

        const existingParentProducts = await getAllPODParentProducts(podDetail.id);
        const existingProducts = await getAllPODProducts(podDetail.id);

        const printfulCategoriesInfo = await getSinglePrintfulInfo(PRINTFUL_INFO_IDS.PRINTFUL_CATEGORIES);
        const printfulProductVariants = await getAllPrintfulProductVariants();
        const printfulParentProducts = await getAllPrintfulProducts();
        const printfulLayoutTemplates = await getAllPrintfulLayoutTemplates();

        const processedParentProducts = preparePrintfulParentProductsForAddOrUpdate(printfulParentProducts, existingParentProducts, printfulCategoriesInfo, printfulLayoutTemplates, podDetail);
        const processedProducts = preparePrintfulProductsForAddOrUpdate(printfulProductVariants, existingProducts, processedParentProducts, podDetail);

        /*await batchSaveProducts(processedProducts.add);
        await batchSaveProducts(processedProducts.update);*/
        await addProducts(processedProducts.add);
        await updateProducts(processedProducts.update);
        console.log('-- Products Sync Done --');

        await addParentProducts(processedParentProducts.add);
        await updateParentProducts(processedParentProducts.update);
        // await batchUpdateParentProducts(processedParentProducts.update);
        console.log('-- Parent Products Sync Done --');

        /*console.log('existingParentProducts', existingParentProducts);
        console.log('printfulParentProducts', printfulParentProducts);*/
        /*console.log('existingProducts', existingProducts);
        console.log('processedProducts', processedProducts);*/
        // console.log('printfulProductVariants', printfulProductVariants);
        // console.log('printfulLayoutTemplates', printfulLayoutTemplates);

        const existingPodDetail = {...podDetail};
        preparePrintfulProductTypeAndCategories(processedParentProducts, existingPodDetail);

        setPodDetail(existingPodDetail);

        setSaveProductsInProgress(false);
    }

    const handleMarketChange = (event) => {
        const {name, value} = event.target;
        const existingPodDetail = {...podDetail};
        existingPodDetail.market = value;
        setPodDetail(existingPodDetail);
    }

    return (
        <>

            <div className="justify-start">
                <div className="flex items-center pb-4 pt-1 px-10">
                    <div className="mr-4">
                        <select
                            className="input-field-max py-3 border border-gray-400 w-48 px-4 mr-2"
                            id="market"
                            name="market"
                            value={podDetail?.market}
                            onChange={handleMarketChange}>
                            <option value="">Choose Market</option>
                            {marketsList?.map((market, index) => (
                                <option key={index}
                                        value={market?.attribute}>{market.label}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        {!saveProductsInProgress &&
                            <button className="button-medium bg-green-500 py-2 px-3"
                                    onClick={syncProductsAndVariants}>
                                Sync Products & Variants
                            </button>
                        }

                        {saveProductsInProgress &&
                            <button className="button-medium bg-gray-500 py-2 px-3"
                                    disabled={saveProductsInProgress}
                                    onClick={() => {
                                    }}>
                                Synching Products & Variants ...
                            </button>
                        }
                    </div>

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={saveProductsInProgress}/>
                    </div>
                </div>

                <div>
                    <ShowTabsList
                        setSelectedTab={setSelectedTab}
                        selectedTab={selectedTab}
                        tabsList={printfulTabsList}/>
                </div>

                <div className="mt-4">
                    {selectedTab?.key === 'stores' &&
                        <div>
                            <PrintfulStoresList/>
                        </div>
                    }

                    {selectedTab?.key === 'categories' &&
                        <div>
                            <PrintfulCategoriesList/>
                        </div>
                    }

                    {selectedTab?.key === 'productTypes' &&
                        <div>
                            <PrintfulProductTypesList/>
                        </div>
                    }

                    {selectedTab?.key === 'products' &&
                        <div>
                            <PrintfulProductsList/>
                        </div>
                    }


                    {selectedTab?.key === 'productVariants' &&
                        <div>
                            <PrintfulProductVariantsList/>
                        </div>
                    }
                </div>


            </div>

        </>
    )
}

export default SyncProductsDashboard
